import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const DiscountCodeValueContext =
  createContext<typeof initialState>(initialState);

const DiscountCodeActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { DiscountCodeActionContext, DiscountCodeValueContext };
